module.exports = __webpack_public_path__ + "media/images/emblems/Guttetfeschel-bf4d3f3ea03e03954e52190401f45ba0.png";